module.exports = __webpack_public_path__ + "img/block-6-left.dd4c0ed0.jpg";